// Anulación de comprobantes: NC que anula una FE y ND que anula una NC.
// Compartido por Historial de Facturas y Notas de Crédito.

// Copia las líneas de un documento para anularlo por completo (NC sobre FE, ND sobre NC).
// IMPORTANTE: copiar también la exoneración y los impuestos adicionales.
export const copiarLineasParaAnular = (docData) => (docData.lineas || []).map((l, idx) => {
  const lineaNC = {
    numeroLinea: idx + 1,
    cantidad: l.cantidad || 1,
    detalle: l.detalle,
    // La unidad define si la línea es servicio (Sp/Os...) o mercancía: sin copiarla,
    // la NC/ND reportaba los servicios de la FE como bienes (quedaba en 'Unid').
    unidadMedida: l.unidadMedida || undefined,
    unidadMedidaComercial: l.unidadMedidaComercial || undefined,
    codigo: l.codigo || undefined,
    codigoComercial: l.sku || l.codigoComercial || undefined,
    precioUnitario: l.precioUnitario || 0,
    descuento: l.descuentoMonto || 0,
    descuentoPorcentaje: l.descuentoPorcentaje || 0,
    impuesto: {
      codigo: '01',
      codigoTarifa: l.impuestoCodigoTarifa || '08',
      tarifa: l.impuestoTarifa || 13
    },
    // Copiar impuestos adicionales (911, Cruz Roja, etc.) de la línea original.
    // Van como "Otros Cargos" en el total; sin esto la NC de anulación quedaría
    // por debajo del monto de la FE y no la anularía por completo.
    impuestosAdicionales: l.impuestosAdicionales || l.impuestos_adicionales || []
  };

  // Copiar exoneración si existe en la línea original
  const exoneracion = l.impuestoExoneracion || l.impuesto_exoneracion;
  if (exoneracion) {
    lineaNC.impuesto.exoneracion = {
      tipoDocumento: exoneracion.tipoDocumento || exoneracion.TipoDocumentoEX1 || '04',
      numeroDocumento: exoneracion.numeroDocumento || exoneracion.NumeroDocumento,
      nombreInstitucion: exoneracion.nombreInstitucion || exoneracion.NombreInstitucion,
      fechaEmision: exoneracion.fechaEmision || exoneracion.FechaEmisionEX,
      porcentaje: exoneracion.porcentaje || exoneracion.TarifaExonerada || exoneracion.PorcentajeExoneracion,
      monto: exoneracion.monto || exoneracion.MontoExoneracion
    };
  }

  return lineaNC;
});

// Nota de Débito que anula una NC aceptada (código de referencia 01, TipoDocIR 03).
// Hacienda no permite anular una NC con otra NC: la ND es el camino.
export const construirNDAnuladora = (nc) => ({
  tipoDocumento: '02',
  receptorId: nc.receptorId || null,
  condicionVenta: nc.condicionVenta || '01',
  medioPago: nc.medioPago || ['01'],
  codigoMoneda: nc.codigoMoneda || 'CRC',
  tipoCambio: parseFloat(nc.tipoCambio) || 1,
  notas: `Anula la Nota de Crédito ${nc.consecutivo}`,
  referencia: {
    tipoDoc: '03',
    numero: nc.clave,
    consecutivo: nc.consecutivo,
    fecha: nc.fechaEmision ? nc.fechaEmision.split('T')[0] : new Date().toISOString().split('T')[0],
    codigo: '01',
    razon: `Anula la Nota de Crédito ${nc.consecutivo}`
  },
  lineas: copiarLineasParaAnular(nc)
});
